import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cnc-picklist-location',
  templateUrl: './picklist-location.component.html',
  styleUrls: ['./picklist-location.component.scss'],
})
export class PicklistLocationComponent implements OnInit {
  @Input()
  pickingLocation :number;
  isPickingLocation :boolean;
  constructor() {}

  ngOnInit() :void {
    this.pickingLocation === 1
      ? (this.isPickingLocation = true)
      : (this.isPickingLocation = false);
  }
}
